export const formatNumber = ({ locale = 'de-DE', value }: { locale?: string; value: any }) => {
  if (typeof value === 'number' || typeof value === 'string') return new Intl.NumberFormat(locale).format(+value);
  return null;
};
